import type { QueryObserverOptions } from '@tanstack/react-query'

import { type GetUsersProfileQueryKey, type GetUsersProfileQueryResponse } from '@/shared/api'
import type { ResponseErrorConfig } from '@/shared/api/axios-client'
import type { GetUsersProfile400 } from '@/shared/api/generated/entities/GetUsersProfile'
import { useGetUsersProfile } from '@/shared/api/generated/hooks/useGetUsersProfile'

interface UseProfileFetchProps {
    query?: Partial<
        QueryObserverOptions<
            GetUsersProfileQueryResponse,
            ResponseErrorConfig<GetUsersProfile400>,
            GetUsersProfileQueryResponse,
            GetUsersProfileQueryResponse,
            GetUsersProfileQueryKey
        >
    >
}

export const useProfileFetch = (props?: UseProfileFetchProps) => {
    const { data, isLoading, error } = useGetUsersProfile({
        query: props?.query,
    })

    return {
        user: data?.user,
        company: data?.user?.company,
        isLoading,
        error,
    }
}
